import React, { FC } from "react";
import { DetailsList } from "@fluentui/react";
import { IColumn } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { SelectionMode } from "@fluentui/react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Nomination, SofView } from "../../models";
import { State } from "../../store";
import { Icon } from "@fluentui/react";
import ProgressIndicator from "../nominations/ProgressIndicator";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as SofViewStore from "../../store/SofViewStore";

type Props = LineHandlingStore.LineHandlingState &
  SofViewStore.SofViewState &
  typeof LineHandlingStore.actionCreators &
  typeof SofViewStore.actionCreators;
const classes = mergeStyleSets({
  viewButton: {
    width: "37px",
    height: "37px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "block",
    padding: "9px 13px",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none"
      }
    }
  },
  viewIcon: {
    color: "#4C4C4C",
    margin: "auto",
    display: "block"
  }
});

const NominationsStatusPane: FC<Props> = (props: Props) => {
  const { lineHandling } = props;

  const columns: IColumn[] = [
    {
      key: "nominationNo",
      name: "Nomination",
      fieldName: "nominationNo",
      minWidth: 80,
      onRender: (item: Nomination) =>
        item.nominationNo.substr(item.nominationNo.length - 6)
    },
    {
      key: "customer",
      name: "Customer",
      fieldName: "customer",
      minWidth: 120
    },
    {
      key: "product",
      name: "Product",
      fieldName: "product",
      minWidth: 120
    },
    {
      key: "direction",
      name: "Direction",
      fieldName: "nominationType",
      minWidth: 80
    },
    {
      key: "progress",
      name: "Progress",
      minWidth: 210,
      onRender: (item: Nomination) => (
        <ProgressIndicator
          label={`${Math.round(item.progress)}% Completed`}
          value={item.progress}
        />
      )
    },
    {
      key: "action",
      name: "",
      minWidth: 54,
      onRender: (item: Nomination) => (
        <Link
          id={`lnk-${item.nominationNo}`}
          className={classes.viewButton}
          to={`/marine/${item.lineHandlingNo}/sof?nomination=${item.nominationNo}`}
        >
          <Icon iconName="OpenFile" className={classes.viewIcon} />
        </Link>
      )
    }
  ];

  if (lineHandling && lineHandling.result)
    return (
      <DetailsList
        columns={columns}
        items={lineHandling.result.nominations}
        selectionMode={SelectionMode.none}
      />
    );
  else return null;
};
export default connect((state: State) => state.lineHandling, {
  ...LineHandlingStore.actionCreators,
  ...SofViewStore.actionCreators
})(NominationsStatusPane as any);
